<template>
  <div>
    <z-modal
      ref="confirmModal"
      @close="close"
    >
      <div class="row mt-3">
        <div class="col-12">
          {{ message }}
        </div>
        <div class="col-12 mt-3">
          <z-button @click="close">
            Close
          </z-button>
        </div>
      </div>
    </z-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ZModal from '@/components/shared/modals/ZModal.vue';
import ZButton from '@/components/shared/buttons/ZButton.vue';

export default {
  components: { ZModal, ZButton },
  data: () => ({
    message: 'Error message',
  }),
  created() {
    this.setLoading(true);
    this.init();
    this.setLoading(false);
  },
  methods: {
    ...mapActions({
      setLoading: 'order/SET_LOADING',
    }),

    init() {
      const { hash } = this.$route.params;

      this.$store.dispatch('emailConfirm', hash)
        .then((response) => {
          if (response.data.success) {
            this.$router.push('/onboarding').catch(() => {});
          } else {
            if (response.data.data) {
              this.message = response.data.data.message;
            }
            this.$refs.confirmModal.open();
          }
        });
    },

    close() {
      this.$router.push('/login').catch(() => {});
    },
  },
};
</script>
